module.exports = __webpack_public_path__ + "img/utah.b6db4956.svg";